export default __webpack_public_path__ + "static/media/header2.824bf5e9.png";